import getConfig from 'next/config'

import type { Context as CartContext } from '@grandvisionhq/carts-v2'
import type { CheckoutSettings, Routes } from '@grandvisionhq/checkout-v2'
import { Util as StoreUtils } from '@grandvisionhq/stores-v2'

interface SettingsInput {
  cart: CartContext.CartContextModel['cart']
}

const { publicRuntimeConfig } = getConfig()
const { orderTimeOut } = publicRuntimeConfig.checkout

export const basePath = '/checkout'
export const routes: Routes = {
  shipping: {
    label: 'Envio',
    path: `${basePath}/envio`,
  },
  overview: {
    label: 'Resumo',
    path: `${basePath}/resumo`,
  },
  payment: {
    label: 'Pagamento',
    path: `${basePath}/pagamento`,
  },
}

export const getCheckoutConfig = ({ cart }: SettingsInput): CheckoutSettings => {
  let shippingDetails: CheckoutSettings['shippingDetails'] | undefined

  if (cart && (cart.billingAddress || cart.shippingAddress || cart.customerDetails)) {
    shippingDetails = {
      ...(cart.billingAddress ? { billingAddress: cart.billingAddress } : {}),
      ...(cart.shippingAddress ? { deliveryAddress: cart.shippingAddress } : {}),
      ...(cart.customerDetails ? { customer: cart.customerDetails } : {}),
    }
  }

  return {
    account: {
      implicitAccountCreation: true,
      createAccountRequired: true,
    },
    consent: {
      implicitTermsAndConditions: true,
    },
    shippingDetails: shippingDetails ? shippingDetails : {},
    storeFinder: {
      showUseMyLocation: true,
      searchWhitelist: ['storeName', 'postalCode', 'streetName', 'town'] as StoreUtils.SearchKey[],
    },
    ...(orderTimeOut ? { orderCreationTimeOutLimit: orderTimeOut } : {}),
    features: {
      isCompanyEnabled: false,
      isServiceStoreEnabled: true,
    },
    login: {
      disableSignup: true,
      returnPath: cart ? `${routes.shipping?.path}?cartId=${cart.id}` : routes.shipping?.path,
    },
    routes,
    logoVariant: 'main',
  }
}
